import { alpha, useTheme } from '@mui/material'
import { Button, Grid } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

const SignButton = ({
    icon,
    label,
    onClick,
    isActive = false,
}: {
    icon: any
    label: string
    onClick: () => void
    isActive?: boolean
}) => {
    const { palette } = useTheme()
    const {
        isLandscapeMobile,
        isMediumScreen,
        isMobile,
        isLandscapeTablet,
    } = useScreenSize()

    return (
        <Button
            id="back-space-btn"
            onClick={onClick}
            sx={{
                backgroundColor: alpha('#fff', 0.2),
                boxShadow: 'none',
                color: '#fff',
                border: '0px solid',
                textTransform: 'uppercase',
                fontSize: 12,
                borderRadius: '100%',
                borderColor: '#fff',
                '&:hover': {
                    backgroundColor: alpha('#fff', 0.2),
                    boxShadow: 'none',
                    color: '#fff',
                },
                '&:focus': {
                    backgroundColor: alpha('#fff', 0.2),
                    boxShadow: 'none',
                    transition: 'ease-out 0.3s',
                },
                '&:active': {
                    backgroundColor: palette.info.main,
                    borderColor: palette.info.main,
                    transition: '0s',
                },
                ...(isLandscapeMobile
                    ? {
                          padding: '8% 4%',
                          maxHeight: 75,
                          maxWidth: 75,
                      }
                    : isMediumScreen && !isLandscapeTablet
                    ? {
                          padding: '15px 21px',
                          maxHeight: 75,
                          maxWidth: 75,
                      }
                    : isMobile
                    ? {
                          padding: '30px 15px',
                          maxHeight: 40,
                          maxWidth: 40,
                      }
                    : isLandscapeTablet
                    ? {
                          padding: '30px 15px',
                          maxHeight: 50,
                          maxWidth: 50,
                      }
                    : {
                          padding: '20px 30px',
                          maxHeight: 100,
                          maxWidth: 100,
                      }),
                ...(isActive
                    ? {
                          backgroundColor: palette.info.main,
                          borderColor: palette.info.main,
                          boxShadow: 'none',
                      }
                    : {}),
            }}
        >
            <Grid container direction="column">
                <Grid
                    item
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    {icon}
                </Grid>
                <Grid item>{label}</Grid>
            </Grid>
        </Button>
    )
}

export default SignButton
